module.exports = __webpack_public_path__ + "img/premium_popup.11b18c74.svg";